import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { buttonBase, StyledTypography } from '../styled.js';
import { jsx } from 'react/jsx-runtime';
import { getToggleButtonAppearance } from '../utils/getToggleButtonAppearance.js';
import { getButtonSize } from '../utils/getButtonSize.js';
import { AiBorderStackingOrderGuard } from '../../../foundation/theme/AiBorderStackingOrderGuard/index.js';

var StyledToggleButton = styled.button.attrs(function (props) {
  return Object.assign(Object.assign({}, props), {
    $stretch: props.stretch || props.$stretch,
    $toggled: props.toggled || props.$toggled
  });
}).withConfig({
  displayName: "StyledToggleButton",
  componentId: "sc-bc54n6-0"
})(["", ";width:", ";z-index:", ";", " ", ";"], buttonBase, function (props) {
  return props.$stretch && "100%;";
}, function (props) {
  return props.$toggled && props.appearance !== 'ai' && "1;";
}, function (props) {
  return getToggleButtonAppearance(props.appearance, props.$toggled);
}, function (props) {
  return getButtonSize(props.size);
});
function ToggleButton(props) {
  var children = props.children,
    appearance = props.appearance;
  if (appearance === 'ai') {
    return /*#__PURE__*/jsx(AiBorderStackingOrderGuard, {
      guard: true,
      children: /*#__PURE__*/jsx(StyledToggleButton, _extends({}, props, {
        children: /*#__PURE__*/jsx(StyledTypography, {
          children: children
        })
      }))
    });
  }
  return /*#__PURE__*/jsx(StyledToggleButton, _extends({}, props, {
    children: children
  }));
}

export { StyledToggleButton, ToggleButton };
